import PatientOverviewPAGoalSettingStrengthTraining from 'dashboard/templates/views/Patient/PA/PatientOverviewPAGoalSettingStrengthTraining';

export default {
  path: 'strength-training',
  name: 'PatientRecordPAGoalSettingStrengthTraining',
  component: PatientOverviewPAGoalSettingStrengthTraining,
  meta: {
    // title: 'Patient Record - Physical Activity - Goal Setting - Strength Training',
    title: t => `${t('patient.patientRecord')} - ${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')} - ${t('pa.strengthTraining')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true,
  }
};
